hasErrors